let formValidationUtilities = require('utilities/formValidationUtilities');
const getMessage = formValidationUtilities.getMessage;

/**
 * Mixin to validate form fields
 * provides a checkValidity function that will check the element's validity
 *	and return a form validation message
 *
 * also provides a "touched" data property to specify if the input has been
 *	checked for validity
 */

module.exports = {
	props: {
		patternMessage: {
			default: null
		},
		overrideMessage: {
			default: null
		}
	},
	data() {
		return {
			touched: false,
			customEl: null,
			message: null
		};
	},
	methods: {
		checkValidity() {
			let el = this.customEl || this.$el;
			let isValid = true;
			let message = '';
			let messageOptions = this.messageOptions();

			// User has touched this input.
			this.touched = true;

			if (el && el.validity) {
				isValid = el.validity.valid;

				if (!isValid) {
					let secondaryValidity = true;
					for (var key in el.validity) {
						if (key !== 'customError' && key !== 'valid' && el.validity[key]) {
							secondaryValidity = false;
						}
					}
					isValid = secondaryValidity;
				}

				if (!isValid) {
					if (this.overrideMessage) {
						message = this.overrideMessage;
					} else {
						message = getMessage(el.validity, messageOptions);
					}
					this.setCustomValidity(message);
				} else {
					this.clearCustomValidity();
				}
			}

			return isValid;
		},
		setCustomValidity(message) {
			let el = this.customEl || this.$el;
			if (this.message === message) {
				return;
			}
			if (el && el.setCustomValidity && message) {
				this.message = message;
				el.setCustomValidity(message);
			}
		},
		clearCustomValidity() {
			let el = this.customEl || this.$el;
			this.message = null;
			if (el && el.setCustomValidity) {
				el.setCustomValidity('');
			}
		},
		// Read properties that should inform error messages.
		// TODO: add min and max values
		messageOptions() {
			let patternMessage = this.patternMessage;
			return {
				patternMessage
			};
		}
	}
};
